import React,{useState} from 'react';
import {
    Button,
    Dialog,
    Message
  } from '@alifd/next';
import moment from 'moment';
import nfc from '../../../lib/nfchelper'
import styles from './MobileCheckin.module.scss'
  
function MobileCheckin() {
  const defaultList=[
      {name:'大門口',value:'尚未巡邏',serial:'3a:5e:e6:a5',ok:false},
      {name:'電梯',value:'尚未巡邏',serial:'c6:df:18:0a',ok:false},
    //   {name:'屋頂',value:'尚未巡邏',serial:'80:c1:9e:5a',ok:false},
  ]
//   const [showNFCD,setShowNFCD]=useState(false)

/* <Dialog
title="請掃描"
visible={showNFCD}
onOk={()=>{setShowNFCD(false)}}
onCancle={()=>{setShowNFCD(false)}}
onClose={()=>{setShowNFCD(false)}}
>請將手機靠近巡檢點</Dialog> */

  const [arrList,setArrList]=useState(defaultList)
  const [isscan,setIsscan]=useState(false)
  return (
    <div className={styles.MobileCheckin}>
        <div className={styles.MobileCheckinTitle}>巡邏勤務</div>
        <div
            className={styles.SuperBigButton}
            style={{backgroundColor:isscan?'#F00':'#0A0'}}
            onClick={() => {
                // setShowNFCD(true)
                // console.log("==window:",window)
                // console.log("==NDEFReader:",window.NDEFReader)
                if(isscan){
                    setIsscan(false)
                    nfc.abort()
                    return
                }
                setIsscan(true)
                nfc.scan(result=>{
                    // setShowNFCD(false)
                    console.log("==scan result",result)
                    if(result.error){
                        Dialog.alert({
                            title:'訊息',
                            content:'本裝置不支援巡邏掃描功能'//JSON.stringify(result,null,2)
                        })
                        setIsscan(false)
                        // arrList[0].value=`已巡邏(${moment().format('MM/DD HH:mm:ss')})`
                        // arrList[0].ok=true
                        // setArrList([...arrList])
                    }else{
                        // Dialog.show({
                        //     title:'卡號',
                        //     content:result.serialNumber
                        // })
                        console.log("==卡號",result.serialNumber)                        
                        let idx = arrList.findIndex(x=>x.serial===result.serialNumber)
                        console.log("==idx",idx)
                        let item = arrList[idx]
                        let time = moment().format('MM/DD HH:mm:ss')
                        if(idx>=0){                            
                            item.value=`已巡邏(${time})`
                            item.ok=true
                        }
                        setArrList([...arrList])
                        Message.success({
                            size:'large',
                            content:`${item.name}已於${time}巡邏完畢`,
                            align:'cc cc'
                        });
                    }
                })
            } }
        >{isscan?'結束巡邏':'開始巡邏'}</div>
        <div className={styles.ListAll}>
        {
            arrList.map(x=>
              <div className={styles.ListItem} style={{color: x.ok? 'green' : 'grey'}}>
                <div className={styles.ListItemName}>{x.name}</div>
                <div className={styles.ListItemValue}>{x.value}</div>
              </div>
            )
        }
        </div>
    </div>
  );
}

export default MobileCheckin;
